import { render, staticRenderFns } from "./IpAddressRestrictionPageDemo.vue?vue&type=template&id=75dd5335&scoped=true"
import script from "./IpAddressRestrictionPageDemo.vue?vue&type=script&setup=true&lang=ts"
export * from "./IpAddressRestrictionPageDemo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IpAddressRestrictionPageDemo.vue?vue&type=style&index=0&id=75dd5335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dd5335",
  null
  
)

export default component.exports